import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const ModalBase = (props) => {
  const { open, closeModal, opObj } = props;
  const maxWidth = props.width ? props.width : "lg";
  const title = props.title ? props.title : props.dialogTitle;
  const addr = props.addr ? props.addr : "";

  return (
    <Dialog open={open} fullWidth maxWidth={maxWidth} className="FxmsPopup">
      <DialogTitle
        id="draggable-dialog-title"
        className="MuiDialogContent-root"
      >
        {title}
        <span
          style={{
            float: "right",
            fontSize: 16,
            fontWeight: 300,
            marginTop: "18px",
          }}
        >
          {addr}
        </span>
        <IconButton
          aria-label="close"
          onClick={closeModal}
          className="MuiButton-root"
          sx={{
            fill: "white",
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon sx={{ fontSize: "2.5rem" }} />
        </IconButton>
      </DialogTitle>
      <DialogContentText></DialogContentText>
      <DialogContent>{props.children}</DialogContent>
      {/* <DialogActions>
      <Button autoFocus onClick={closeModal}>Close</Button>
    </DialogActions> */}
    </Dialog>
  );
};
